var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"dropdown-menu-icon shadow border-0"},[_c('li',_vm._l((_vm.dropdownList),function(item,index){return _c('span',{key:index,staticClass:"dropdown-item",on:{"click":function($event){return _vm.logType(item)}}},[_vm._v(_vm._s(item.title))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }